'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('I18n/components');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _colors = require('HubStyleTokens/colors');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _UsageTracker = require('MeetingsLib/tracking/UsageTracker');

var _getFreemiumViralLink = require('MeetingsLib/components/freemium/getFreemiumViralLink');

var _getFreemiumViralLink2 = _interopRequireDefault(_getFreemiumViralLink);

var _paths = require('MeetingsLib/constants/paths');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FreemiumBookingUpgradeLink',
  goToMeetingsPage: function goToMeetingsPage(viralLink) {
    (0, _UsageTracker.track)('meetingsLibClickPromoLink', {
      page: 'booking'
    });
    window.open(viralLink, '_blank');
  },
  renderUpgradeLink: function renderUpgradeLink() {
    var _this = this;

    var viralLink = (0, _getFreemiumViralLink2.default)(_paths.BOOKING_VIRAL_HUBS_CTA);

    return _react2.default.createElement(
      _UIButton2.default,
      {
        style: { width: 'inherit' },
        use: 'link',
        onClick: function onClick() {
          _this.goToMeetingsPage(viralLink);
        }
      },
      _react2.default.createElement(_components.FormattedMessage, { message: 'prebook.freemium.linkText' })
    );
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'text-center p-y-3', style: { color: _colors.EERIE } },
      _react2.default.createElement(_UIIcon2.default, { name: icons.SPROCKET, color: _colors.LORAX, className: 'm-right-1' }),
      _react2.default.createElement(_components.FormattedReactMessage, {
        message: 'prebook.freemium.ctaText',
        options: {
          linkText: this.renderUpgradeLink()
        }
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/freemium/FreemiumBookingUpgradeLink.js
// module id = 396
// module chunks = 0